import Vue from "vue"
import { store } from "@/store/store"

let auth = new Vue({
  store,
  computed: {
    token: {
      get: function () {
        return localStorage.getItem("id_token")
      },
      set: function (idToken) {
        localStorage.setItem("id_token", idToken)
      }
    },
    accessToken: {
      get: function () {
        return localStorage.getItem("access_token")
      },
      set: function (accessToken) {
        localStorage.setItem("access_token", accessToken)
      }
    },
    expiresAt: {
      get () {
        return localStorage.getItem("expires_at")
      },
      set: function (expiresIn) {
        localStorage.setItem(
          "expires_at", 
          JSON.stringify(expiresIn * 1000 + new Date().getTime())
        )
      }
    },
    user: {
      get: function () {
        return JSON.parse(localStorage.getItem("user"))
      },
      set: function (user) {
        localStorage.setItem("user", JSON.stringify(user))
      }
    }
  },
  methods: {
    getExpiresAt () {
      return  localStorage.getItem("expires_at")
    },
    logout () {
      return new Promise(resolve => {
        localStorage.removeItem("access_token")
        localStorage.removeItem("id_token")
        localStorage.removeItem("expires_at")
        localStorage.removeItem("user")
        this.$store.commit("soundsys/setLogged", false)
        window.location.replace(window.location.origin)
        resolve()
      })
    },
    isAuthenticated () {
      let logged = new Date().getTime() < this.getExpiresAt()
      return logged
    },
    setSession (authResult) {
      // Set the time that the access token will expire at
      let expiresAt = JSON.stringify(
        authResult.expires_in * 1000 + new Date().getTime()
      )
      localStorage.setItem("access_token", authResult.access_token)
      localStorage.setItem("id_token", authResult.id_token)
      localStorage.setItem("expires_at", expiresAt)
    },
    clearSession () {
      localStorage.removeItem("access_token")
      localStorage.removeItem("id_token")
      localStorage.removeItem("expires_at")
      localStorage.removeItem("society")
    },
    authenticate (data) {
      // Set the time that the access token will expire at
      let expiresAt = JSON.stringify(
        data.expires_in * 1000 + new Date().getTime()
      )
      localStorage.setItem("access_token", data.access_token)
      localStorage.setItem("id_token", data.id_token)
      localStorage.setItem("expires_at", expiresAt)
      return new Promise((resolve, reject) => {
        if (data && data.access_token && data.id_token) {

          this.expiresAt = data.expires_in
          this.accessToken = data.access_token
          this.token = data.id_token
          this.$store.commit("soundsys/setLogged", true)

          resolve()
        } else {
          this.logout()

          reject()
        }
      })
    }
  }
})

export const Authentication = {
  install (Vue) {
    Vue.prototype.$auth = auth
  }
}
